export const CategorizedListItemCategory = ({ children }) => (
  <span className="text-darkBlack font-semibold">{children}</span>
)
